import { useState } from "react";
import { connectWallet } from "../web3/ritual";

type Props = {
  onConnected: (address: string) => void;
};

export function WalletConnect({ onConnected }: Props) {
  const [address, setAddress] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    try {
      setLoading(true);
      const addr = await connectWallet();
      setAddress(addr);
      onConnected(addr);
      window.gtag?.("event", "connect_wallet");
    } catch (e: any) {
      alert(e?.message || "Failed to connect wallet");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button className="btn" onClick={handleConnect} disabled={loading}>
      {address
        ? `Connected: ${address.slice(0, 6)}...${address.slice(-4)}`
        : loading
        ? "Connecting..."
        : "Connect Wallet"}
    </button>
  );
}